module.exports = __webpack_public_path__ + "media/images/nereport/icon_nega0-8df6bf7d560dfaabba24a2ee3f1e625e.svg";